import { render } from "./Sound.vue?vue&type=template&id=57f3f32c"
import script from "./Sound.vue?vue&type=script&lang=js"
export * from "./Sound.vue?vue&type=script&lang=js"

import "./Sound.vue?vue&type=style&index=0&id=57f3f32c&lang=scss"
script.render = render

export default script